import type { ISwivuProject } from "@/types/SwivuProject";
import { STORE_KEYS } from "@/other/constants/StoreKeys.jsx";
import type { BoardContextGroup } from "@/bryntum-lib/models/BoardContextGroup";

export const recordHasNonPreviewGroups = (
  project: ISwivuProject | null | undefined,
  contextId: number
): boolean => {
  if (!project) return false;
  const store = project.getCrudStore(STORE_KEYS.boardContextGroupStore);
  if (!store) return false;
  return (store.records as unknown as BoardContextGroup[]).some(
    (g) => g.boardContext === contextId && !g.isPreview
  );
};
